import React from "react";
import { Chip, Divider, MenuItem, Stack, Typography } from "@mui/material";
import { GlassPanel, ModernTextField } from "../styledComponents";

const DATE_FIELD_WIDTH = { xs: "100%", md: "50%" };
const VALUE_FIELD_WIDTH = { xs: "66.6667%", md: "41.6667%" };
const UNIT_FIELD_WIDTH = { xs: "33.3333%", md: "25%" };

const GLUCOSE_TESTS = [
  {
    label: "Glucosa a cualquier hora",
    name: "glucosaCualquierHora",
    units: ["mg/dL", "mmol/L"],
  },
  {
    label: "Glucosa en ayuno",
    name: "glucosaAyuno",
    units: ["mg/dL"],
  },
  {
    label: "Hemoglobina glucosilada",
    name: "hemoglobinaGlucosilada",
    units: ["%"],
  },
  {
    label: "Tolerancia oral a la glucosa",
    name: "toleranciaOralGlucosa",
    units: ["mg/dL", "mmol/L"],
  },
];

const PruebasGlucosa = ({ formValues, onChange }) => {
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    onChange(name, value);
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <GlassPanel>
      <Stack spacing={3}>
        <Stack spacing={1}>
          <Typography variant="overline" sx={{ letterSpacing: 3 }}>
            Análisis clínico
          </Typography>
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", color: "primary.main" }}
          >
            Pruebas de glucosa
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Lleva un registro de las mediciones más relevantes para evaluar la
            respuesta glucémica del paciente en diferentes contextos.
          </Typography>
          <Stack direction="row" spacing={1}>
            {["Control", "Histórico", "Seguimiento"].map((tag) => (
              <Chip key={tag} label={tag} size="small" variant="outlined" />
            ))}
          </Stack>
        </Stack>

        <Divider />

        <Stack spacing={3}>
          {GLUCOSE_TESTS.map((test) => (
            <Stack
              key={test.name}
              spacing={2}
              sx={{
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 3,
                p: 2.5,
                backgroundColor: (theme) => theme.palette.background.paper,
              }}
            >
              <Stack spacing={0.5}>
                <Typography variant="subtitle2" color="text.secondary">
                  {test.label}
                </Typography>
                <Typography variant="caption" color="text.disabled">
                  Registra fecha y valor para comparar en tus consultas.
                </Typography>
              </Stack>

              <ModernTextField
                label="Fecha"
                name={`fecha${test.name}`}
                type="date"
                value={formValues[`fecha${test.name}`] || ""}
                onChange={handleInputChange}
                fullWidth
                inputProps={{ max: today }}
                InputLabelProps={{ shrink: true }}
                helperText="Última medición registrada"
                sx={{ width: DATE_FIELD_WIDTH }}
              />

              <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={2}
                sx={{ flexWrap: "wrap" }}
              >
                <ModernTextField
                  label="Valor"
                  name={test.name}
                  type="number"
                  value={formValues[test.name] || ""}
                  onChange={handleInputChange}
                  fullWidth
                  sx={{ width: VALUE_FIELD_WIDTH }}
                />
                <ModernTextField
                  select
                  label="Unidad"
                  name={`${test.name}Medida`}
                  value={formValues[`${test.name}Medida`] || test.units[0]}
                  onChange={handleInputChange}
                  fullWidth
                  sx={{ width: UNIT_FIELD_WIDTH }}
                >
                  {test.units.map((unit) => (
                    <MenuItem key={unit} value={unit}>
                      {unit}
                    </MenuItem>
                  ))}
                </ModernTextField>
              </Stack>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </GlassPanel>
  );
};

export default PruebasGlucosa;
